import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLinePay = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#pet__clip0_17324_8462)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fill: "black",
				d: "M7.34702 1H6.48507C6.35075 1 6.25 1.1057 6.25 1.22196V6.27422C6.25 6.40106 6.36194 6.49618 6.48507 6.49618H7.34702C7.48134 6.49618 7.58209 6.39049 7.58209 6.27422V1.22196C7.58209 1.1057 7.48134 1 7.34702 1Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "black",
				d: "M5.26492 5.2384H2.94775V1.22196C2.94775 1.09513 2.83581 1 2.71268 1H1.85074C1.71641 1 1.61566 1.1057 1.61566 1.22196V6.27422C1.61566 6.40106 1.7276 6.49618 1.85074 6.49618H5.26492C5.39924 6.49618 5.49999 6.39049 5.49999 6.27422V5.47093C5.51118 5.3441 5.39924 5.2384 5.26492 5.2384Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "black",
				d: "M18.0597 2.26835C18.194 2.26835 18.2948 2.16265 18.2948 2.04639V1.22196C18.2948 1.09513 18.1828 1 18.0597 1H14.6343C14.5 1 14.3992 1.1057 14.3992 1.22196V6.27422C14.3992 6.40106 14.5112 6.49618 14.6343 6.49618H18.0485C18.1828 6.49618 18.2836 6.39049 18.2836 6.27422V5.47093C18.2836 5.3441 18.1716 5.24897 18.0485 5.24897H15.7313V4.38227H18.0485C18.1828 4.38227 18.2836 4.27657 18.2836 4.16031V3.34645C18.2836 3.21961 18.1716 3.12449 18.0485 3.12449H15.7313V2.26835H18.0597Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "black",
				d: "M13.2463 1H12.3955C12.2612 1 12.1604 1.1057 12.1604 1.22196V4.14974L9.89925 1.1057C9.83209 1.02114 9.74254 1 9.6306 1C9.6194 1 9.60821 1 9.58582 1H8.73507C8.60075 1 8.5 1.1057 8.5 1.22196V6.27422C8.5 6.40106 8.61194 6.49618 8.73507 6.49618H9.59702C9.73134 6.49618 9.83209 6.39049 9.83209 6.27422V3.23018L12.1828 6.40106C12.194 6.41163 12.2052 6.4222 12.2052 6.43277C12.25 6.47504 12.306 6.50675 12.3731 6.51732C12.3843 6.51732 12.3955 6.51732 12.4179 6.51732H13.2575C13.3918 6.51732 13.4925 6.41163 13.4925 6.29536V1.22196C13.4925 1.1057 13.3806 1 13.2463 1Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#08BF5B",
				d: "M18.3507 8.3457H1.64925C1.29104 8.3457 1 8.62051 1 8.95874V18.3868C1 18.725 1.29104 18.9998 1.64925 18.9998H18.3507C18.709 18.9998 19 18.725 19 18.3868V8.96931C19 8.63108 18.709 8.3457 18.3507 8.3457Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "white",
				d: "M7.48132 12.5095C7.48132 13.4502 6.68655 14.2006 5.6567 14.2006H4.87312V15.5852C4.87312 15.6804 4.79476 15.7544 4.69401 15.7544H3.85446C3.75371 15.7544 3.67535 15.6804 3.67535 15.5852V10.9875C3.67535 10.8923 3.75371 10.8184 3.85446 10.8184H5.6567C6.68655 10.8184 7.48132 11.5688 7.48132 12.5095ZM6.29476 12.5095C6.29476 12.1501 6.0261 11.8753 5.6567 11.8753H4.87312V13.1437H5.6567C6.0261 13.1437 6.29476 12.8689 6.29476 12.5095Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "white",
				d: "M11.9142 12.3086V15.6591C11.9142 15.712 11.8694 15.7437 11.8246 15.7437H10.8955C10.8395 15.7437 10.806 15.7014 10.806 15.6591V15.416C10.5597 15.6803 10.1903 15.8494 9.69776 15.8494C8.72388 15.8494 7.91791 15.0355 7.91791 13.9892C7.91791 12.9428 8.72388 12.1289 9.69776 12.1289C10.2015 12.1289 10.5597 12.2874 10.806 12.5623V12.3192C10.806 12.2663 10.8507 12.2346 10.8955 12.2346H11.8246C11.8806 12.224 11.9142 12.2663 11.9142 12.3086ZM10.7948 13.9892C10.7948 13.4607 10.4254 13.133 9.91044 13.133C9.39552 13.133 9.02612 13.4607 9.02612 13.9892C9.02612 14.5176 9.39552 14.8453 9.91044 14.8453C10.4254 14.8453 10.7948 14.5176 10.7948 13.9892Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "white",
				d: "M15.6418 12.3197L14.7798 14.3597L13.8955 12.3197C13.8731 12.2669 13.8172 12.2246 13.75 12.2246H12.7985C12.7313 12.2246 12.6866 12.288 12.7089 12.3409L14.1866 15.7549L13.6492 17.0443C13.6269 17.0972 13.6716 17.1606 13.7388 17.1606H14.6903C14.7575 17.1606 14.8134 17.1289 14.8358 17.0655L16.8172 12.3409C16.8395 12.288 16.7948 12.2246 16.7276 12.2246H15.7761C15.7201 12.2246 15.6642 12.2669 15.6418 12.3197Z"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "pet__clip0_17324_8462",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgLinePay);
export default ForwardRef;
